import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader } from '..';
import en from '../../../../lang/en-us';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { OtpField, ResendOtp, useTimer } from '../../../../lib/OtpField';
import OtpSentTextWrapper from '../../../../lib/OtpSentTextWrapper';
import {
    verifyChangeEmailOTP as verifyOTP,
    updateEmail,
    sendPhoneOTP,
    updateMobile,
    sendMobileOTP,
} from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { addDialCode, OTP_ACTIONS } from '../../../../utils/constants';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import {
    getPortfoliosFilteredData,
    portfoliosByMinorStatus,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { RowInfoType } from '../ChangeEmail/change-email-list';
import { nextScreen, SUCCESS } from './flow';

const { dashboard } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function OtpVerification(props: any) {
    const {
        mobile = null,
        onSuccessNavigationUrl = 'change-mobile-new',
        // images = [],
        mobileRelationship,
        data: selectedFunds,
        foliosToUpdate,
        heading = '',
        fromUnregisteredFolio = false,
        action,
    } = props.location.state || {};

    const images =
        props?.location?.state?.action === OTP_ACTIONS.NEW_MOBILE_OFFLINE_OTP
            ? props?.imageInfo?.data
            : [];
    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const { otp, reqId, otpRef } = props.location.state || {};
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const { pan, pekrn, mobile } = props;
            const goTo = nextScreen(props.match.path);
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                pan,
                pekrn,
                mobile: addDialCode(mobile),
                action,
            };

            await props.verifyOTP(payload);
            if (goTo === SUCCESS) {
                await onUpdateMobile();
                return;
            }
            props.history.replace(goTo, { ...(props?.location?.state || {}) });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const onUpdateMobile = async () => {
        try {
            const {
                portfolios = {},
                pan,
                pekrn,
                mobile: existingMobile,
                userRegisteredWith,
            } = props;
            // const { data: folioList = [] } = portfolios;
            // const filters: Function[] = [portfoliosByTransactionResource, portfoliosByMinorStatus];
            // let folios: RowInfoType[] = getPortfoliosFilteredData(folioList, filters);
            const data = foliosToUpdate?.map((ele: RowInfoType) => {
                return {
                    amc: ele.amc,
                    folio: ele.id,
                    newMobile: mobile,
                    mobileRelationship,
                };
            });
            let payload = {
                data: selectedFunds ? selectedFunds : data,
                pan,
                pekrn,
                reqId,
                mobile: existingMobile,
                ...(fromUnregisteredFolio ? { source: 'U' } : { source: 'R' }),
            };
            let updatedPayload = images.length ? { ...payload, images } : payload;
            let res =
                userRegisteredWith == 'EMAIL'
                    ? await props.updateEmail(updatedPayload)
                    : await props.updateMobile(updatedPayload);
            const successUrl = 'change-mobile-success';
            props.history.replace(successUrl, {
                mobile: mobile,
                isOffline: images.length ? true : false,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    const onResend = async () => {
        try {
            const { pan, pekrn } = props;
            let payload = {
                ...(action === OTP_ACTIONS.changeMobile ? {} : { mobile: addDialCode(mobile) }),
                pan,
                pekrn,
                action,
            };
            let res = await props.sendMobileOTP(payload);
            setShowModal(true);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader
                header={!!heading ? heading : dashboard.ChangeMobile.ChangeMobileHeading}
            />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="icon" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        {/* <p>
                            {dashboard.OtpScreen.otpPhoneSubject}{' '}
                            <span>{maskMobileNumber(mobile)}</span>
                        </p> */}
                        <OtpSentTextWrapper _mobile={props?.location?.state?.mobile} />
                        {/* <p>
                            {dashboard.OtpScreen.otpPhoneSubject}{' '}
                            <span>
                                {mobile}, OTP : {otp}
                            </span>
                        </p> */}
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            maskedInfo={`Please enter the 6-digit OTP sent to ${maskMobileNumber(
                                mobile,
                            )}`}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    {
        verifyOTP,
        updateEmail,
        sendPhoneOTP,
        updateMobile,
        sendMobileOTP,
    },
)(OtpVerification);
